import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { combineLatest, firstValueFrom, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { Felt } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';
import { ProfileStateDispatcher } from 'src/app/core/state/profile/profile.dispatcher';
import { ProfileComponentId } from 'src/app/core/state/profile/profile.state';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Navigation]);

@Component({
    selector: 'app-felt',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './felt.component.html',
    styleUrls: ['./felt.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FeltComponent implements OnInit {
    @Input() feltsArray: Felt[];
    @Output() feltPageEmitter = new EventEmitter<ProfileComponentId>();
    @ViewChild('feltSlide') feltSlide: SwiperComponent;
    activeFelt$: Observable<Felt>;
    myFelts$: Observable<Felt[]>;
    sliderOptions: SwiperOptions = {
        slidesPerView: 4,
        pagination: false,
        navigation: true,
    };
    constructor(
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        private gameSettingsService: GameSettingsService,
        private popoverController: PopoverController,
        @Optional() public sopoDialogRef: SopoDialogRef,
        private sopoPopupService: SopoPopupService,
        private profileStateDispatcher: ProfileStateDispatcher,
    ) { }

    ngOnInit() {
        this.activeFelt$ = this.gameThemeSettingsDispatcher.getActiveFelt();
        const myFeltsState$ = this.gameThemeSettingsDispatcher.getMyFeltsState();
        if (this.feltsArray) {
            this.myFelts$ = myFeltsState$.pipe(
                map(myFelts => this.gameSettingsService.mergeItems(myFelts, this.feltsArray)),
            );
        } else {
            const feltsArrayPromise = this.gameSettingsService.loadAllItemsFromCms<Felt>('felts');
            this.myFelts$ = combineLatest([myFeltsState$, feltsArrayPromise]).pipe(
                map(([myFelts, feltsArray]) => this.gameSettingsService.mergeItems(myFelts, feltsArray)),
            );
        }
    }
    getFelt(id: number) {
        const feltId = GameSettingsService.getFeltId(id);
        return {
            'background': `url("/assets/img/tables/table-${feltId}.webp") center no-repeat`,
            'background-size': '200%'
        };
    }
    async onSelect(item: Felt) {
        const activeFelt = await firstValueFrom(this.activeFelt$);
        if (item.id === activeFelt.id) return;
        if (this.sopoDialogRef) {
            this.sopoDialogRef.close();
        } else if (!this.feltsArray) this.popoverController.dismiss();
        if (!item.type) item.type = 'local';
        this.gameSettingsService.markItemAsPurchasedAndSelect<Felt>(item, 'felts');
        return;
        if(!item.purchased){
        this.sopoPopupService
            .promptForConfirmation('app', {
                data: {
                    header: `Are you sure you want to purchase this item for ${item.price} diamonds?`,
                    okText: `Yes`,
                    cancelText: 'No'
                }
            })
            .then((confirmed) => {
                if (confirmed) {
                    this.gameSettingsService.selectAndPurchaseItem<Felt>(item, 'felts');
                }
            });
        }
        else {
            this.gameSettingsService.selectAndPurchaseItem<Felt>(item, 'felts');
        }
    }

    trackFelts(index: number, felt: Felt): string {
        return felt.id.toString();
    }

    async openCommunityFeltMenu() {
        if (this.sopoDialogRef) {
            await this.sopoDialogRef.close();
        }
        if (this.feltsArray) {
            this.feltPageEmitter.emit('community-felts-component');
        } else {
            this.profileStateDispatcher.activateComponent('community-felts-component');
        }
    }

    ngOnDestroy(): void {}
}
